import { useParams } from "react-router-dom";
import { RouteParams } from "../helper/router";
import { AlertTab } from "model/state";

export function useAlertParams(): RouteParams {
  const { currentTab } = useParams();

  return {
    currentTab: (currentTab || 'all') as AlertTab
  }
}
